import { setWebChannel } from "../utils/emarsys-web-channel"
import getCookie from "../utils/getCookie"

const lang = getCookie("django_language") || "de"
const cookieExpiresAfterDays = 365

var emarsysBaseConfig = {
  description: {
    de: "Marketing und personalisierte Inhalte",
    en: "Marketing and personalised content",
  },
  cookies: ["scarab.visitor", "scarab.profile", "s"],
}

function descriptionFromConfig(serviceConfig, lang) {
  const { description, cookies } = serviceConfig
  return [
    description[lang],
    cookies?.length && `${cookies.length === 1 ? "Cookie" : "Cookies"}: ${cookies.join(", ")}`,
    cookieExpiresAfterDays != null &&
      (lang === "de"
        ? `Speicherdauer: ${cookieExpiresAfterDays} Tage`
        : `Storage Period: ${cookieExpiresAfterDays} Days`),
  ]
    .filter(Boolean)
    .join("<br>\n")
}

var klaroConfig = {
  version: 1,
  elementID: "klaro-consent",
  storageName: "klaro",
  storageMethod: "localStorage",
  htmlTexts: true,
  mustConsent: true,
  acceptAll: false,
  default: false,
  cookieExpiresAfterDays: cookieExpiresAfterDays,
  lang: lang,
  showDescriptionEmptyStore: true,
  noAutoLoad: false,
  embedded: false,
  groupByPurpose: false,
  autoFocus: true,
  showNoticeTitle: false,
  hideDeclineAll: false,
  hideLearnMore: false,
  noticeAsModal: false,

  translations: {
    zz: {
      privacyPolicyUrl: "/privacy-policy",
    },
    de: {
      consentModal: {
        title: "Wir benötigen Ihr Einverständnis",
        description:
          "Wir nutzen Cookies, um Ihr Erlebnis zu verbessern und personalisierte Inhalte zu ermöglichen. Ihre Präferenzen können Sie hier individuell speichern.",
      },
      purposes: {
        marketing: {
          title: "Marketing",
        },
      },
      emarsys: { description: descriptionFromConfig(emarsysBaseConfig, "de") },
    },
    en: {
      consentModal: {
        title: "We need your consent!",
        description:
          "We use cookies to enhance your experience and enable personalized content. You can save your preferences for them individually here.",
      },
      purposes: {
        marketing: {
          title: "Marketing",
        },
      },
      emarsys: {
        description: descriptionFromConfig(emarsysBaseConfig, "en"),
      },
    },
  },

  services: [
    {
      name: "emarsys",
      title: "Emarsys Web Extend",
      default: false,
      required: false,
      onlyOnce: false,
      purposes: ["marketing"],
      cookies: emarsysBaseConfig.cookies,
      optOut: false,
      onDecline: () => {
        const scarabScript = document.getElementById("scarab-js-api")
        if (scarabScript?.parentNode) {
          window.location.reload()
        }

        window.ScarabQueue = []

        Object.keys(localStorage)
          .filter((x) => x.startsWith("wps-") || x.startsWith("_wp") || x.startsWith("scarab"))
          // biome-ignore lint/suspicious/useIterableCallbackReturn: removeItem() called for side effects
          .forEach((x) => localStorage.removeItem(x))

        Object.keys(sessionStorage)
          .filter((x) => x.startsWith("wps"))
          // biome-ignore lint/suspicious/useIterableCallbackReturn: removeItem() called for side effects
          .forEach((x) => sessionStorage.removeItem(x))

        setWebChannel(true)
      },
    },
  ],
}

export default klaroConfig
